import { setDocumentTitle } from "@/shared/lib/document-title";

import { router } from "./router";

interface PageMetadata {
  title: string;
  description?: string;
}

const defaultTitle = document.title;
const defaultDescription = document.querySelector<HTMLMetaElement>('meta[name="description"]')?.content ?? "";

/** 保留入口 HTML 的默认信息，导航后只覆盖当前路由提供的内容。 */
export function subscribeDocumentMetadata() {
  const descriptionTag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
  const openGraphDescription = document.querySelector<HTMLMetaElement>('meta[property="og:description"]');

  const update = () => {
    const page = router.state.matches
      .map((match) => match.route.handle as PageMetadata | undefined)
      .filter((handle): handle is PageMetadata => Boolean(handle?.title))
      .pop();
    const title = page ? `${page.title} - Pinbox` : defaultTitle;
    const description = page?.description ?? defaultDescription;

    setDocumentTitle(title);
    if (descriptionTag) descriptionTag.content = description;
    if (openGraphDescription) openGraphDescription.content = description;
  };

  let currentPath = `${router.state.location.pathname}${router.state.location.search}`;
  let initialized = router.state.initialized;
  update();
  return router.subscribe((state) => {
    const nextPath = `${state.location.pathname}${state.location.search}`;
    if (nextPath === currentPath && state.initialized === initialized) return;
    currentPath = nextPath;
    initialized = state.initialized;
    update();
  });
}
